module.exports = __webpack_public_path__ + "static/img/icon-search.51262be.png";